import { Component, OnInit, Input, Output, OnChanges, EventEmitter,Injectable, ChangeDetectionStrategy} from '@angular/core';
import { SharedService } from '../../../../component/shared/shared.service';
import { MedicalHistory } from '../../../master/model/medical-history' ;
import { AppointmentService } from '../../../appointment/service/appointment.service';
import { Patient} from '../../model/patient';
import { Appointment } from '../../../appointment/model/appointment';
import { PatientService } from '../../service/patient-service.service';
import { MedicalHistoryService } from '../../../master/services/medical-history.service'; 
import { DialogAction, ActionMessage } from '../../../../shared/enum/dialog-action.enum';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
  @Input() patient : Patient ;
  appointmentList : Appointment[] = [] ;
  selectedScheduleObject : Appointment;
  isErrorMessage : boolean = false;
  isSuccessMessage : boolean = false;
  patientInfo : Patient;
  Aloading : boolean = false;
  message : string;
  constructor(private _sharedService: SharedService, private _usrService : PatientService, private _appSrv : AppointmentService) { 
    _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'APPOINTMENTCANCELE') {
              this.cancelAppointmentData(text.Data);
          }  
      });
      _sharedService.bookingEmitted$.subscribe(
        text => {
          if(this.patient !== undefined && this.patient !== null) {
            this.GetPatientAppointment();
          } 
        });
  }
  GetPatientAppointment() : void {
    this.Aloading = true;
    this.appointmentList = [];
    this._usrService.getPatientAppointment(this.patient.PatientId).subscribe(data=>{
      this.Aloading = false;
        this.appointmentList = data;
        let appList  =data.filter(function(app){
          return (app.AppointmentIsCancelled === false);
        });
        /*var appData = this.appointmentList.filter(function(app){
          return (app.AppointmentIsCancelled === false);
        })*/
        this._usrService.publishText( appList);
    },
    error=>{
      this.Aloading = false;
    });
  }
  ngOnInit() {
   this.GetPatientAppointment();
  }
  ngOnChanges() {
    //this.GetPatientAppointment();
   }
  
 
  cancelAppointmentData(appData : Appointment) {
    if(appData !== undefined) {
      appData['isLoading'] = true;
      this._appSrv.cancelAppointment(appData.AppointmentDoctorId, appData.AppointmentClinicId, appData.AppointmentDay, appData.AppointmentTime ).subscribe(data=>{
          this.isSuccessMessage = true;
          if(data.Status==0) {
            alert(data.Message);
          } else {
            this.GetPatientAppointment();
            this.message = "Appointment canceled successfully";
            appData['isLoading'] = false;
          }
          appData['isLoading'] = false;
      }, error=> {
        this.isErrorMessage = true;
         this.message = "Appointment not canceled";
         appData['isLoading'] = false;
      })
    }
    
 }
  cancelAppointment(data : Appointment) {
    this.selectedScheduleObject =data;
    this._sharedService.emitDialog(true, "Deactivate", ActionMessage.CANCEL.toString(),true,DialogAction.DELETE.toString(), 'APPOINTMENTCANCELE', this.selectedScheduleObject);  

  }

}



// WEBPACK FOOTER //
// ./src/app/section/patient/view-patient-profile/appointment/appointment.component.ts